import { createApp } from 'vue'
import 'virtual:svg-icons-register'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

import App from './App.vue'
import { setupStore } from '@/stores'
import router, { setupRouter } from './router'
import { updateDarkSign } from './theme'
import * as directive from './directives'
import componentsArr from './components/index.js'
import { initUMeng } from '@/plugins/initUMeng'
import { initSentry } from '@/plugins/initSentry'
async function bootstrap() {
  // 引入友盟统计
  initUMeng()
  const app = createApp(App)
  // //自定义指令
  for (const i in directive) {
    app.directive(i, directive[i])
  }

  // // 公共组件 注册
  componentsArr.forEach((item) => {
    app.component(item.__name ?? item.name, item)
  })

  setupStore(app)
  // 挂载路由
  setupRouter(app)
  await router.isReady()
  const route = router.currentRoute.value
  if (route.query.openDebug) localStorage.setItem('openDebug', 1)
  // 注册sentry
  initSentry(app, router)
  // 路由准备就绪后挂载APP实例
  app.mount('#app')

  // 根节点挂载 dark 标识
  const appDesignSetting = window.localStorage.getItem('DESIGN-SETTING')
  const darkMode = appDesignSetting && JSON.parse(appDesignSetting).darkMode
  updateDarkSign(darkMode)
}
bootstrap()
